import React from 'react';
import styled from 'styled-components';

const TableContainer = ({ children }) => {
  return <Container>{children}</Container>;
};

export const Container = styled.div`
  padding: 10px;
  background: white;
  border-radius: 5px;
  margin-top: 16px;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1);
  font-family: 'SFProRegular';
`;

export default TableContainer;
